import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import "./Invoice.css";
import { useSelector, useDispatch } from "react-redux";
import { fetchPestTypes } from "../../Redux/pestTypesSlice";

import { createInvoice } from "../../Redux/api";

export function resetForm(formRef) {
  if (!formRef || !formRef.current) return;
  formRef.current.reset();
}

const Invoice = () => {
  const navigate = useNavigate();
  const formRef = React.useRef(null);
  const dispatch = useDispatch();
  const pestTypes = useSelector((state) => state.pestTypes.items);
  const pestTypesStatus = useSelector((state) => state.pestTypes.status);
  const [guaranteeValue, setGuaranteeValue] = useState("");

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (pestTypesStatus === "idle") {
      dispatch(fetchPestTypes());
    }
  }, [dispatch, pestTypesStatus]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");
    const form = formRef.current;
    const dateOfService = form["datePicker"].value;
    const customerName = form["txtName"].value.trim();
    const address = form["txtAddress"].value.trim();
    const pestServiceId = form["txtPestType"].value;
    const mobileNumber = form["txtMobileNumber"].value.trim();
    const guaranteePeriod = form["txtGuarantee"].value;
    const guaranteeUnit = form["txtGuaranteeUnit"].value;
    const village = form["txtVillage"].value.trim();
    const city = form["txtCity"].value.trim();
    const state = form["txtState"].value.trim();
    const amount = form["txtAmount"].value.trim();
    
    // Validation: all required except village
    if (
      !dateOfService ||
      !customerName ||
      !address ||
      !pestServiceId ||
      !mobileNumber ||
      !guaranteePeriod ||
      !guaranteeUnit ||
      !city ||
      !state ||
      !amount
    ) {
      setError("Please add required fields.");
      return;
    }
    // Mobile validation
    if (!/^([1-9]{1}[0-9]{9})$/.test(mobileNumber)) {
      setError("Mobile number must be 10 digits and not start with 0.");
      return;
    }

    const invoiceData = {
      dateOfService,
      customerName,
      address,
      pestServiceId,
      mobileNumber,
      guaranteePeriod,
      guaranteeUnit,
      village,
      city,
      state,
      amount,
    };
    setLoading(true);
    createInvoice(invoiceData)
      .then(() => {
        setLoading(false);
        navigate("/list-customers");
      })
      .catch((err) => {
        setLoading(false);
        setError("Failed to submit invoice. Please try again.");
      });
  };

  const handleReset = () => {
    resetForm(formRef);
    setError("");
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ minHeight: "100vh" }}
    >
      <form
        ref={formRef}
        className="bg-white p-4 rounded shadow"
        style={{ minWidth: "40%" }}
        onSubmit={handleSubmit}
      >
        <h1
          className="text-center mb-4 header-name"
          onClick={() => navigate("/list-customers")}
        >
          India Pest Control Services
        </h1>
        {error && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}
        <div className="form-group row justify-content-center">
          <label className="col-sm-3 col-form-label">Date</label>
          <div className="col-sm-6">
            <input
              type="date"
              className="form-control form-control-sm"
              id="datePicker"
            />
          </div>
        </div>
        <div className="form-group row justify-content-center">
          <label className="col-sm-3 col-form-label">Name</label>
          <div className="col-sm-6">
            <input
              type="text"
              className="form-control form-control-sm"
              id="txtName"
              placeholder="Customer name"
            />
          </div>
        </div>
        <div className="form-group row justify-content-center">
          <label className="col-sm-3 col-form-label">Address</label>
          <div className="col-sm-6">
            <textarea
              className="form-control form-control-sm"
              id="txtAddress"
              placeholder="Customer address"
              rows="5"
            />
          </div>
        </div>
        <div className="form-group row justify-content-center">
          <label className="col-sm-3 col-form-label">Service</label>
          <div className="col-sm-6">
            <select
              className="form-control form-control-sm"
              id="txtPestType"
              defaultValue=""
            >
              <option value="" disabled>
                Please select
              </option>
              {pestTypes.map((type) => (
                <option key={type.id} value={type.id}>
                  {type.pestType}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="form-group row justify-content-center">
          <label className="col-sm-3 col-form-label">Mobile Number</label>
          <div className="col-sm-6">
            <input
              type="text"
              className="form-control form-control-sm"
              id="txtMobileNumber"
              placeholder="Customer Mobile Number"
              maxLength="10"
              pattern="[1-9]{1}[0-9]{9}"
            />
          </div>
        </div>
        <div className="form-group row justify-content-center">
          <label className="col-sm-3 col-form-label">Guarantee Period</label>
          <div className="col-sm-3">
            <input
              type="number"
              className="form-control form-control-sm"
              id="txtGuarantee"
              placeholder="Guarantee Period"
              value={guaranteeValue}
              min="1"
              onChange={(e) => setGuaranteeValue(e.target.value)}
            />
          </div>
          <div className="col-sm-3">
            <select
              className="form-control form-control-sm"
              id="txtGuaranteeUnit"
              defaultValue=""
            >
              <option value="" disabled>
                Please select
              </option>
              {guaranteeValue === "1" ? (
                <>
                  <option>Day</option>
                  <option>Month</option>
                  <option>Year</option>
                </>
              ) : (
                <>
                  <option>Days</option>
                  <option>Months</option>
                  <option>Years</option>
                </>
              )}

              {/* <option>Days</option>
              <option>Months</option>
              <option>Years</option> */}
            </select>
          </div>
        </div>
        <div className="form-group row justify-content-center">
          <label className="col-sm-3 col-form-label">Village</label>
          <div className="col-sm-6">
            <input
              type="text"
              className="form-control form-control-sm"
              id="txtVillage"
              placeholder="Village name"
            />
          </div>
        </div>
        <div className="form-group row justify-content-center">
          <label className="col-sm-3 col-form-label">City</label>
          <div className="col-sm-6">
            <input
              type="text"
              className="form-control form-control-sm"
              id="txtCity"
              placeholder="City name"
            />
          </div>
        </div>
        <div className="form-group row justify-content-center">
          <label className="col-sm-3 col-form-label">State</label>
          <div className="col-sm-6">
            <input
              type="text"
              className="form-control form-control-sm"
              id="txtState"
              placeholder="State name"
            />
          </div>
        </div>
        <div className="form-group row justify-content-center">
          <label className="col-sm-3 col-form-label">Amount</label>
          <div className="col-sm-6">
            <input
              type="number"
              className="form-control form-control-sm"
              id="txtAmount"
              placeholder="Amount"
              step="0.01"
              min="0"
            />
          </div>
        </div>
        {loading && (
          <div className="text-center mb-2">
            <span
              className="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>{" "}
            Submitting...
          </div>
        )}
        <div className="text-center mt-4">
          <button type="submit" className="btn btn-primary btn-sm px-4 mr-2">
            Submit
          </button>
          <button
            type="button"
            className="btn btn-secondary btn-sm px-4"
            onClick={handleReset}
          >
            Reset
          </button>
        </div>
      </form>
    </div>
  );
};

export default Invoice;
